
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ar"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46json_5111540e",
      load: () => import("#nuxt-i18n/5111540e" /* webpackChunkName: "locale_en_45US_46json_5111540e" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ae_45AE_46json_d86877ae",
      load: () => import("#nuxt-i18n/d86877ae" /* webpackChunkName: "locale_ae_45AE_46json_d86877ae" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "English",
      dir: "ltr",
      files: [
        {
          path: "/app/i18n/locales/en-US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      language: "ar-AE",
      name: "العربية",
      dir: "rtl",
      files: [
        {
          path: "/app/i18n/locales/ae-AE.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    dir: "ltr",
    files: [
      {
        path: "/app/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    language: "ar-AE",
    name: "العربية",
    dir: "rtl",
    files: [
      {
        path: "/app/i18n/locales/ae-AE.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/